"use client";

import { Tabs as Base } from "@base-ui/react/tabs";
import { createContext, forwardRef, useContext, useState } from "react";
import type { ButtonHTMLAttributes, HTMLAttributes } from "react";
import { slotted } from "./shared";

type RootProps = HTMLAttributes<HTMLDivElement> & { value?: string; defaultValue?: string; onValueChange?: (value: string) => void; orientation?: "horizontal" | "vertical"; activationMode?: "automatic" | "manual" };
const Context = createContext({ value: "", automatic: true });
export const Root = forwardRef<HTMLDivElement, RootProps>(function Root({ value: controlled, defaultValue = "", onValueChange, activationMode = "automatic", ...props }, ref) {
  const [internal, setInternal] = useState(defaultValue);
  const value = controlled ?? internal;
  return <Context.Provider value={{ value, automatic: activationMode === "automatic" }}><Base.Root {...props} ref={ref} value={value} onValueChange={next => { if (typeof next !== "string") return; if (controlled === undefined) setInternal(next); onValueChange?.(next); }} /></Context.Provider>;
});
export const List = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement> & { loop?: boolean }>(function List({ loop = true, ...props }, ref) {
  const context = useContext(Context);
  return <Base.List {...props} ref={ref} loopFocus={loop} activateOnFocus={context.automatic} />;
});
export const Trigger = forwardRef<HTMLButtonElement, ButtonHTMLAttributes<HTMLButtonElement> & { value: string }>(function Trigger(props, ref) {
  const context = useContext(Context);
  return <Base.Tab {...props} ref={ref} data-state={context.value === props.value ? "active" : "inactive"} />;
});
export const Content = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement> & { value: string; forceMount?: boolean; asChild?: boolean }>(function Content({ forceMount, asChild, children, ...props }, ref) {
  const context = useContext(Context);
  return <Base.Panel {...props} ref={ref} keepMounted={forceMount} hidden={forceMount ? false : undefined} data-state={context.value === props.value ? "active" : "inactive"} {...slotted(asChild, children)} />;
});
